import { Component, Input, OnInit, inject } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { map } from 'rxjs/operators';
import { some, isEmpty } from 'lodash';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { IdentityEntityGroup } from 'projects/bis-shared/src/lib/auth/security-models';
import { Roles } from 'projects/bis-shared/src/lib/utility/roles';
import { MatCardModule } from '@angular/material/card';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { PriorAuthQueueComponent } from '../../prior-auth-queue/prior-auth-queue.component';
import { DraftEformsQueueComponent } from '../../eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from '../../eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';

@Component({
  selector: 'app-healthcare-provider-dashboard',
  templateUrl: './healthcare-provider-dashboard.component.html',
  styleUrls: ['./healthcare-provider-dashboard.component.scss'],
  imports: [
    MatCardModule,
    MatTabsModule,
    MatTabGroup,
    PriorAuthQueueComponent,
    DraftEformsQueueComponent,
    SubmittedEformsQueueComponent,
  ],
})
export class HealthcareProviderDashboardComponent implements OnInit {
  private identityService = inject(IdentityService);

  AppUrls = AppUrls;

  selectedTabIndex: number;
  hidePriorAuth: boolean;
  @Input() redirectToTabIndex: number;

  
 

  

  ngOnInit(): void {
    this.identityService.identity$.pipe(map(identity => identity?.entityGroups)).subscribe(eg => {
      this.hidePriorAuth = !some(eg, (g: IdentityEntityGroup) => (
        g.entityTypeCode === EntityTypeCode.HealthcareProvider &&
          some(g.userRoleCodes, (r: Roles) => !isEmpty(r) && r !== Roles.HPBillingDelegate)
      ));

      if (this.hidePriorAuth && !this.selectedTabIndex) {
        this.selectedTabIndex = 1;
      }
    });
  }
}
